import React from 'react';
import { useTranslation } from 'react-i18next';

const AboutUs = () => {
  const { t, i18n } = useTranslation();

  const isRTL = i18n.language === 'ar';

  return (
    <div
      style={{
        direction: isRTL ? 'rtl' : 'ltr',
        padding: '60px 20px',
        maxWidth: '1200px',
        margin: '0 auto',
      }}
    >
      <h1 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '30px' }}>
        {t("aboutTitle")}
      </h1>

      <section style={{ marginBottom: '50px' }}>
        <h2>{t("whoWeAre")}</h2>
        <p>{t("whoWeAreDesc")}</p>
      </section>

      <section style={{ marginBottom: '50px' }}>
        <h2>{t("ourMission")}</h2>
        <p>{t("missionDesc")}</p>
      </section>

      <section style={{ marginBottom: '50px' }}>
        <h2>{t("ourVision")}</h2>
        <p>{t("visionDesc")}</p>
      </section>

      <section>
        <h2>{t("ourValues")}</h2>
        <ul>
          <li>{t("value1")}</li>
          <li>{t("value2")}</li>
          <li>{t("value3")}</li>
        </ul>
      </section>
    </div>
  );
};

export default AboutUs;
